import auth from '@/auth/auth'

export default {
  state: {
    auth: auth.getAuth(),
    userInfo: auth.getUserInfo(),
    establecimiento:  auth.getEstablecimiento()
  },
  mutations: {
    setAuthentication (state, token) {
      console.log('setAuthentication', token)
      state.auth = token
      auth.setAuth(token)
    },
    removeAuthentication (state) {
      state.userInfo = null
      state.establecimiento = null
      state.auth = null
      auth.clear()
    },
    setUserInfo (state, userInfo) {
      console.log('setUserInfo', userInfo)
      state.userInfo = userInfo;
      auth.setUserInfo(userInfo);
    },
    setEstablecimiento (state, establecimiento_id) {
      console.log('setEstablecimiento', establecimiento_id);
      var establecimiento = state.userInfo ? state.userInfo.Establecimientos.find(function(element) {
        return establecimiento_id === element.Id;
      }) : null;
      state.establecimiento = establecimiento;
      window.sessionStorage.setItem('establecimiento', JSON.stringify(establecimiento));
    },
  },
  actions: {
    login (context, credentials) {
      return auth.login(credentials).then(resAuth => {
        //console.log('setAuthentication', resAuth.data)
        context.commit('setAuthentication', resAuth.data);
      })
    },
    userInfo (context) {
      return auth.getUserInfo().then(res => {
        context.commit('setUserInfo', res.data);
        console.log('set establecimiento por defecto', res.data.Establecimientos[0]);
        context.commit('setEstablecimiento', res.data.Establecimientos[0].Id);
        return res;
      });
    },
    logout (context) {
      auth.logout()
      context.commit('removeAuthentication')
    },
    setEstablecimiento (context, establecimiento_id) {
      context.commit('setEstablecimiento', establecimiento_id);
    },
  },
  getters: {
    getAuth (state) {
      console.log('getAuth', state)
      return state.auth
    },
    isAuthenticated (state) {
      console.log('isAuthenticated userStore')
      return state.auth !== null && typeof state.auth !== 'undefined'
    },
    getUserName(state){
      console.log('getUserName userStore', state.auth.userName);
      return state.auth.userName;
    },
    getUserInfo(state){
      console.log("getUserInfo", state.userInfo);
      //...
      return state.userInfo;
    },
    getEstablecimiento(state){
      console.log("getEstablecimiento", state.establecimiento);
      //...
      return state.establecimiento;
    },
    getSelectEstablecimiento(state){
      console.log("getSelectEstablecimiento", state.userInfo);
      var options = state.userInfo ? state.userInfo.Establecimientos.map(
        function(item) {
          console.log('item',item);
          return {
            value:item.Id,
            text:item.DisplayNivelAsignado
            };
        }) : [];
      return options;
    },
    isInRoleAdmin (state) {
      var role = 'Admin';
      var roles = state.userInfo ? state.userInfo.Roles : [];
      return auth.isInRole(role, roles);
    },
    isInRoleEstablecimiento (state) {
      var role = 'Establecimiento';
      var roles = state.userInfo ? state.userInfo.Roles : [];
      return auth.isInRole(role, roles);
    },
    isInRoleCoordinador (state) {
      var role = 'Coordinador';
      var roles = state.userInfo ? state.userInfo.Roles : [];
      return auth.isInRole(role, roles);
    },
    isInRoleRecMedico (state) {
      var role = 'ReconocimientoMedico';
      var roles = state.userInfo ? state.userInfo.Roles : [];
      return auth.isInRole(role, roles);
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/user.js